enum CommitRawTxType {
  AcceptOffer = "AcceptOffer",
  Bid = "Bid",
  BuyEdition = "BuyEdition",
  BuyNow = "BuyNow",
  CancelListing = "CancelListing",
  ChangePrice = "ChangePrice",
  ChangePriceForEditions = "ChangePriceForEditions",
  ClaimPnft = "ClaimPnft",
  List = "List",
  ListEditions = "ListEditions",
  MakeOffer = "MakeOffer",
  ManageSeriesPieces = "ManageSeriesPieces",
  MintMasterEdition = "MintMasterEdition",
  SellInstantSale = "SellInstantSale",
  SetTickSize = "SetTickSize",
  SettleAuction = "SettleAuction",
  SignMetadata = "SignMetadata",
  SoldGenerativeMint = "SoldGenerativeMint",
  StoppedMintingForEditions = "StoppedMintingForEditions",
  UpdateMetadata = "UpdateMetadata",
}

export default CommitRawTxType;
